import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";
import MenuToggle from "../../assets/images/svg/icon-menu.svg";
import Nav from "components/nav/nav";

const MobileMenu = () => {
  const [active, setActive] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const isDutch = router.locale === "nl-be";
  const isTurkish = router.locale === "tr-tr";
  const label = active
    ? (isTurkish ? "Menüyü kapat" : isDutch ? "Menu sluiten" : "Close menu")
    : (isTurkish ? "Menüyü aç" : isDutch ? "Menu openen" : "Open menu");

  useEffect(() => {
    const closeAfterNavigation = () => setActive(false);
    router.events.on("routeChangeComplete", closeAfterNavigation);
    return () => router.events.off("routeChangeComplete", closeAfterNavigation);
  }, [router.events]);

  useEffect(() => {
    if (!active) return;
    toggleRef.current?.focus();
    const wasLocked = document.body.classList.contains("overflow-hidden");
    document.body.classList.add("overflow-hidden");
    const close = () => {
      setActive(false);
      toggleRef.current?.focus();
    };
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        close();
      }
      if (event.key === "Tab") {
        const links = Array.from(menuRef.current?.querySelectorAll<HTMLElement>(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'
        ) || []);
        const first = toggleRef.current;
        const last = links[links.length - 1] || first;
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    };
    const desktop = window.matchMedia("(min-width: 1024px)");
    const handleResize = () => { if (desktop.matches) setActive(false); };
    document.addEventListener("keydown", handleKeyDown);
    desktop.addEventListener("change", handleResize);
    return () => {
      if (!wasLocked) document.body.classList.remove("overflow-hidden");
      document.removeEventListener("keydown", handleKeyDown);
      desktop.removeEventListener("change", handleResize);
    };
  }, [active]);

  return (
    <div className="mobile-menu">
      <button
        ref={toggleRef}
        type="button"
        onClick={() => setActive((current) => !current)}
        aria-label={label}
        aria-expanded={active}
        aria-controls="mobile-navigation"
        className={classNames("mobile-menu__toggle", { "is-active": active })}
      >
        <MenuToggle aria-hidden="true" focusable="false" />
      </button>
      <div id="mobile-navigation" ref={menuRef} className="mobile-menu__modal" hidden={!active}>
        {active && <>
          <Nav target="HeaderLeftMenu" />
          <Nav target="HeaderRightMenu" className="nav--utils" />
        </>}
      </div>
    </div>
  );
};

export default MobileMenu;
